export default __webpack_public_path__ + "static/media/268.dad293a0.jpg";